import React from 'react';
import PropTypes from 'prop-types';
import { CardTitle, Link, Typography } from '@one-thd/sui-atomic-components';
import { ListView } from '@one-thd/sui-icons';
import { CreateAList } from '@thd-olt-component-react/list-forms';
import { trackLearnMoreClick, trackCreateListClick } from '../../utils/analyticsHelpers';
import { NAVIGATION_URLS } from '../../constants/navigationUrls';

const ListsHeader = ({ listCount, actions = [], clickID }) => {

  const handleLearnMoreClick = () => {
    trackLearnMoreClick();
    // Navigate to create list page
    window.location.href = NAVIGATION_URLS.LEARN_MORE;
  };

  const handleListCreation = (newList) => {
    trackCreateListClick();
    // Trigger analytics event when list is successfully created
    if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS) {
      window.LIFE_CYCLE_EVENT_BUS.trigger('list-forms.create-without-products');
    }

    const id = newList?.id;
    if (id) {
      window.location.href = `/list/view/details/${id}`;
    }
  };

  const createNewLinkButton = ({ onClick }) => (
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    <Link
      href="#"
      onClick={(eve) => {
        eve.preventDefault();
        // Just trigger the drawer
        onClick();
      }}
    >
      Create New
    </Link>
  );

  const actionMap = {
    viewAll: (
      <Link href={NAVIGATION_URLS.VIEW_ALL_LISTS}>
        View All Lists
      </Link>
    ),
    learnMore: (
      <Link
        href={NAVIGATION_URLS.LEARN_MORE}
        onClick={handleLearnMoreClick}
        // eslint-disable-next-line react/no-unknown-property
        data-analytics-region={clickID}
      >
        Learn More
      </Link>
    ),
    createNew: (
      <CreateAList
        CustomCreateListActionElement={createNewLinkButton}
        onCreate={handleListCreation}
      />
    )
  };

  const renderAction = (action) => {
    return actionMap[action] || null;
  };

  const validActions = actions.filter((action) => actionMap[action]);

  const renderedActions = validActions.length > 0 ? (
    <div className="sui-flex sui-gap-2">
      {validActions.map((action, index) => (
        <div key={`action-${action}-${index}`} className="sui-flex sui-items-center">
          {renderAction(action)}
          {index < validActions.length - 1 && (
            <div className="sui-ml-2">|</div>
          )}
        </div>
      ))}
    </div>
  ) : null;

  return (
    <CardTitle
      header={(
        <div className="sui-flex sui-gap-3 sui-items-center">
          <ListView />
          <div className="sui-flex sui-gap-2 sui-items-center">
            <Typography variant="h4" weight="display">
              Lists
            </Typography>
            {listCount > 0 && (
              <Typography variant="body-base">
                ({listCount})
              </Typography>
            )}
          </div>
        </div>
      )}
      data-testid="lists-header"
      actionPosition="end"
      action={renderedActions}
    />
  );
};
ListsHeader.propTypes = {
  listCount: PropTypes.number,
  actions: PropTypes.arrayOf(
    PropTypes.oneOf(['viewAll', 'learnMore', 'createNew'])
  ),
  clickID: PropTypes.string,
};

ListsHeader.defaultProps = {
  listCount: 0,
  actions: [],
  clickID: undefined
};

export default ListsHeader;
